import Vue from 'vue'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'

import Main from '../components/Main'
import Accounts from '../components/modules/Accounts'
import Packages from '../components/modules/Packages'
import Channels from '../components/modules/Channels'
import Services from '../components/modules/Services'
import Categories from '../components/modules/Categories'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Roles from "../components/modules/Roles";
import Users from "../components/modules/Users";
import Login from "../components/modules/Login";
import Logout from "../components/modules/Logout";
import EPG_Sources from "../components/modules/EPG_Sources";
import EPG_Channels from "../components/modules/EPG_Channels";
import CAS_Servers from "../components/modules/CAS_Servers";
import Colocations from "../components/modules/Colocations";
import Statistics from "../components/modules/Statistics";
import StatisticsChannelsBySessionsByDate from "../components/modules/StatisticsChannelsBySessionsByDate";
import LogRequests from "../components/modules/LogRequests";
import LogSessions from "../components/modules/LogSessions";
import Apks from "../components/modules/Apks";
import Streams from "../components/modules/Streams";
import VodMovies from "../components/modules/VodMovies";
import VodPackages from "../components/modules/VodPackages";
import VodGenres from "../components/modules/VodGenres";
import VodServices from "../components/modules/VodServices";
import VodMovieStreams from "../components/modules/VodMovieStreams";

Vue.use(Router)
Vue.use(BootstrapVue);

export default new Router({
  mode  : 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    // {
    //   path: '/',
    //   name: 'Statistics',
    //   component: Statistics
    // },
    {
      path: '/accounts',
      name: 'Accounts',
      component: Accounts
    },
    {
      path: '/packages',
      name: 'Packages',
      component: Packages
    },
    {
      path: '/channels',
      name: 'Channels',
      component: Channels
    },
    {
      path: '/services',
      name: 'Services',
      component: Services
    },
    {
      path: '/colocations',
      name: 'Colocations',
      component: Colocations
    },
    {
      path: '/categories',
      name: 'Categories',
      component: Categories
    },
    {
      path: '/roles',
      name: 'Roles',
      component: Roles
    },
    {
      path: '/users',
      name: 'Users',
      component: Users
    },
    {
      path: '/sources',
      name: 'EPG_Sources',
      component: EPG_Sources
    },
    {
      path: '/source-channels',
      name: 'EPG_Channels',
      component: EPG_Channels,
    },
    {
      path: '/source-channels/:source_id',
      name: 'EPG_SourceChannels',
      component: EPG_Channels,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/Statistics',
      name: 'Statistics',
      component: Statistics
    },
    {
      path: '/StatisticsChannelsBySessionsByDate',
      name: 'StatisticsChannelsBySessionsByDate',
      component: StatisticsChannelsBySessionsByDate
    },
    {
      path: '/logrequests',
      name: 'LogRequests',
      component: LogRequests
    },    
    {
      path: '/logsessions',
      name: 'LogSessions',
      component: LogSessions
    },    
    {
      path: '/Apks',
      name: 'Apks',
      component: Apks
    },
    {
      path: '/streams/:channel_id',
      name: 'Streams',
      component: Streams,
    },
    {
      path: '/vod_movies',
      name: 'VodMovies',
      component: VodMovies
    },
    {
      path: '/vod_packages',
      name: 'VodPackages',
      component: VodPackages
    },
    {
      path: '/vod_genres',
      name: 'VodGenres',
      component: VodGenres
    },
    {
      path: '/vod_services',
      name: 'VodServices',
      component: VodServices
    },
  ] 
})



// WEBPACK FOOTER //
// ./src/router/index.js